// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


import "babel-polyfill";

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// 全局引入mint-ui
// 引入全局模块
import Mint from 'mint-ui'
import 'mint-ui/lib/style.min.css'
import preview from 'vue-photo-preview';
import MideaIcon from './components/Icon';

// 引入公共样式类 --- 主题
import './assets/styles/public.css';
import 'vue-photo-preview/dist/skin.css';

import VueQriously from 'vue-qriously'

import * as fitlers from '@/utils/filter';

Vue.use(VueQriously)
Vue.use(Mint)

let options = {
  fullscreenEl: false, //控制是否显示右上角全屏按钮
  tapToClose: true,
  clickToCloseNonZoomable: true
};

Vue.use(preview, options)
Vue.component(MideaIcon.name, MideaIcon)

// 引入全局样式
// import 'mint-ui/lib/'

// 注册全局过滤器，导出的是对象，可以直接通过 key 和 value 来获得过滤器的名和过滤器的方法
Object.keys(fitlers).forEach(key => {
  Vue.filter(key, fitlers[key])
})

Vue.config.productionTip = false


// 忽略自定义元素标签抛出的报错
Vue.config.ignoredElements = [
  'wx-open-launch-app',
  'wx-open-launch-weapp'
];


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js